import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import db from '../firebase';

const ContactForm = () => {
  const location = useLocation();
  const initialModel = location.state?.model || 'Axia';

  const [formData, setFormData] = useState({
    name: '',
    nric: '',
    phone: '',
    model: initialModel,
    purpose: '',
    preferredDate: '',
    preferredTime: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  useEffect(() => {
    if (location.state?.model) {
      setFormData((prev) => ({ ...prev, model: location.state.model }));
    }
  }, [location.state?.model]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Add form data to Firestore "mail" collection
      const docRef = await addDoc(collection(db, 'mail'), {
        ...formData,
        to: 'rangka.raya.sls@gmail.com',
        message: {
          subject: 'Online Inquiry from '+formData.name+' for '+formData.purpose,
          html: 'Name: '+formData.name+'<br>NRIC: '+formData.nric+'<br>Phone: '+formData.phone+'<br>Model: '+formData.model+'<br>Purpose: '+formData.purpose+'<br>Preferred Date: '+formData.preferredDate+'<br>Preferred Time: '+formData.preferredTime,
        },
        timestamp: serverTimestamp(),
        submittedAt: new Date().toISOString()
      });
      
      console.log('Form submitted successfully with ID: ', docRef.id);
      setSubmitStatus('success');
      alert('Thank you for your inquiry! We will contact you soon.');
      
      // Reset form
      setFormData({ name: '', nric: '', phone: '', model: 'Axia', purpose: 'TEST DRIVE', preferredDate: '', preferredTime: '' });
    } catch (error) {
      console.error('Error submitting form: ', error);
      setSubmitStatus('error');
      alert('Sorry, there was an error submitting your inquiry. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="section" style={{background: '#e9ecef'}}>
      <div className="contact-container">
        <h2 style={{textAlign: 'center', marginBottom: '20px'}}>General Inquiry Form</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name*</label>
            <input 
              type="text" 
              name="name"
              placeholder="Your Name" 
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>NRIC*</label>
            <input 
              type="text" 
              name="nric"
              placeholder="Your NRIC" 
              value={formData.nric}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Phone Number*</label>
            <input 
              type="tel" 
              name="phone"
              placeholder="012-3456789" 
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Interested Model*</label>
            <select 
              name="model"
              value={formData.model}
              onChange={handleChange}
              required
            >
              <option>Axia</option>
              <option>Myvi</option>
              <option>Bezza</option>
              <option>Alza</option>
              <option>Ativa</option>
              <option>Aruz</option>
              <option>Traz</option>
            </select>
          </div>
          <div className="form-group">
            <label>Purpose of Inquiry*</label>
            <select 
              name="purpose"
              value={formData.purpose}
              onChange={handleChange}
              required
            >
              <option value="TEST DRIVE">TEST DRIVE</option>
              <option value="BOOKING">BOOKING</option>
              <option value="OTHERS">OTHERS</option>  
            </select>
          </div>
          <div className="form-group">
            <label>Preferred Date</label>
            <input 
              type="date" 
              name="preferredDate"
              value={formData.preferredDate}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Preferred Time</label>
            <input 
              type="time" 
              name="preferredTime"
              value={formData.preferredTime}
              onChange={handleChange}
            />
          </div>
          <button 
            type="submit" 
            className="cta-btn" 
            style={{
              width: '100%', 
              border: 'none', 
              cursor: isSubmitting ? 'not-allowed' : 'pointer', 
              fontSize: '1.1rem',
              opacity: isSubmitting ? 0.7 : 1
            }}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit Inquiry'}
          </button>
          {submitStatus === 'error' && (
            <p style={{color: 'red', marginTop: '10px', textAlign: 'center'}}>
              Error submitting form. Please try again.
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
